/**
 * Mixin xử lý validate combobox
 */
import i18nValidate from '@/i18ns/vi/i18nValidate';
export const validateCombobox = {
  /**
   * @override
   */
  validateRule(rule, editor) {
    const me = this;
    const res = true;
    let message = '';
    const titleError = editor.getTitleError();
    let isValidMultiCombobox = true;
    switch (rule) {
      case 'forceSelection':
        if (!me.validateForceSelection(editor)) {
          message = i18nValidate.messages[rule](titleError);
        }

        break;
      case 'notSelectParent':
        if (!me.validateNotSelectParent(editor)) {
          message = i18nValidate.messages[rule](titleError);
        }
        break;
      case 'required':
        let controlValue = editor.getValue();
        const isValidCommon =
            controlValue === undefined || controlValue === null || controlValue === NaN || controlValue === '';
          
        // Đối với trường hợp chọn nhiều thì khi xóa hết item đã chọn nhưng vẫn đang nhập 1 giá trị trong ô input
        // Thì đang check trống chứ không check sai item chọn
        // Ở đây phải bind giá trị ng dùng đang nhập vào để hiểu được là đang chọn như ko phải trống
        if (editor.isComboboxMulti && editor.$refs.input?.value) {
          isValidMultiCombobox = false;
          controlValue = editor.$refs.input?.value;
        }
        if (isValidCommon && isValidMultiCombobox) {
          message = i18nValidate.messages[rule](titleError);
        }
        break;
    }

    return message;
  },

  /**
   * Xử lý force selection
   * @param {*} editor
   * @return
   * HTHIEP 01.07.2022: Sửa lại việc lấy item theo text => case thêm trường hợp có suffix
   */
  validateForceSelection(editor) {
    const me = this;
    let isValid = editor?.internalText; // Trường hợp thường thì internalText = giá trị trong ô input
    // Trường hợp combobox chọn nhiều thì internalText là giá trị được chọn -> trường hợp này check cả giá trị ô nhập nữa
    if(editor.isComboboxMulti && editor.$refs.input?.value){
      isValid = true;
    }
    if (isValid) {
      // nếu là binding trên grid
      if (editor.$cell && editor.queryMode === 'remote' && !editor.lastRequestParam) {
        return true;
      }

      const dataSource = editor.internalDataSource;

      // nếu là binding thì trả về true
      // pvduy 29/06/2021: sửa lỗi khi hủy form thêm mới trên combobox thì ko cảnh báo.
      if (
        editor.internalText === editor.initText &&
        dataSource.length === 0 &&
        (!me.forceSelection || me.internalValue) &&
        // pntoan 12.12.2023 Bổ sung thêm điều kiện forceSelection của combobox chọn nhiều
        // Đối với combobox chọn nhiều thì nếu mà chưa nhập gì thì không sao
        // Và các control không phải combobox chọn nhiều thì chạy theo logic code cũ ở trên ( ko sửa j )
        ((editor.isComboboxMulti && !editor.$refs.input?.value) || !editor.isComboboxMulti)
      ) {
        return true;
      }

      if (dataSource && dataSource.length > 0) {
        if (editor.value) {
          return true;
        }
        const valueText = editor.internalText;
        const items = editor.findItemByText(valueText);
        if (items && items.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  },
  /**
   * ĐVThi 05/02/2020: Validate bắt buộc chọn con, không được chọn cha
   */

  validateNotSelectParent(editor) {
    if (editor) {
      const item = editor.internalSelectedItem;
      if (item && item.hasOwnProperty('isParent') && item['isParent']) {
        return false;
      }
    }
    return true;
  },
};
